export const products = [
  {
    id: '1',
    name: 'Standard Rollator Walker',
    category: 'Mobility Aids',
    description: 'Lightweight aluminum rollator with adjustable height, padded seat, and locking hand brakes. Features storage pouch and foldable design for easy transport.',
    features: ['300 lb weight capacity', 'Tool-free assembly', 'Adjustable height 31-37 inches', 'Built-in seat'],
    image: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&q=80'
  },
  {
    id: '2',
    name: 'Heavy Duty Rollator',
    category: 'Mobility Aids',
    description: 'Extra-wide bariatric rollator with reinforced frame. Designed for maximum stability and support.',
    features: ['500 lb weight capacity', 'Extra-wide seat', 'Heavy-duty construction', 'Large wheels'],
    image: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&q=80'
  },
  {
    id: '3',
    name: 'Standard Transport Wheelchair',
    category: 'Mobility Aids',
    description: 'Companion-operated transport chair with swing-away footrests. Compact design ideal for travel and transport.',
    features: ['19-inch seat width', 'Lightweight frame', 'Foldable design', 'Companion brakes'],
    image: 'https://images.unsplash.com/photo-1615461066841-6116e61058f4?w=800&q=80'
  },
  {
    id: '4',
    name: 'Self-Propelled Wheelchair',
    category: 'Mobility Aids',
    description: 'Manual wheelchair with large rear wheels for self-propulsion. Includes desk-length armrests and swing-away footrests.',
    features: ['18-20 inch seat options', 'Adjustable footrests', 'Removable armrests', '250 lb capacity'],
    image: 'https://images.unsplash.com/photo-1615461066841-6116e61058f4?w=800&q=80'
  },
  {
    id: '5',
    name: 'Bariatric Wheelchair',
    category: 'Mobility Aids',
    description: 'Heavy-duty wheelchair with reinforced frame and extra-wide seat for larger patients.',
    features: ['24-30 inch seat widths', '600-1000 lb capacity', 'Reinforced construction', 'Heavy-duty wheels'],
    image: 'https://images.unsplash.com/photo-1615461066841-6116e61058f4?w=800&q=80'
  },
  {
    id: '6',
    name: 'Adjustable Walking Cane',
    category: 'Mobility Aids',
    description: 'Aluminum cane with ergonomic handle and height adjustment. Available in various handle styles.',
    features: ['Height adjustable', '250 lb capacity', 'Rubber tip', 'Multiple colors'],
    image: 'https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=800&q=80'
  },
  {
    id: '7',
    name: 'Quad Cane',
    category: 'Mobility Aids',
    description: 'Four-point base cane providing enhanced stability. Ideal for those requiring extra balance support.',
    features: ['Large or small base options', 'Height adjustable', '300 lb capacity', 'Non-slip tips'],
    image: 'https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=800&q=80'
  },
  {
    id: '8',
    name: 'Folding Cane',
    category: 'Mobility Aids',
    description: 'Portable folding cane that collapses for easy storage and transport. Perfect for travel.',
    features: ['Compact when folded', 'Height adjustable', 'Comes with carrying case', 'Lightweight'],
    image: 'https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=800&q=80'
  },
  {
    id: '9',
    name: 'Standard Walker',
    category: 'Mobility Aids',
    description: 'Traditional folding walker without wheels. Provides maximum stability for those with balance concerns.',
    features: ['No wheels - maximum stability', '300 lb capacity', 'Foldable', 'Height adjustable'],
    image: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&q=80'
  },
  {
    id: '10',
    name: 'Two-Wheel Walker',
    category: 'Mobility Aids',
    description: 'Front-wheeled walker combining stability with easier maneuverability. Ideal for indoor use.',
    features: ['Front wheels', 'Rear glides', 'Foldable design', 'Height adjustable'],
    image: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&q=80'
  },
  {
    id: '11',
    name: 'Knee Walker',
    category: 'Mobility Aids',
    description: 'Alternative to crutches for lower leg injuries. Allows hands-free mobility while keeping weight off injured foot.',
    features: ['Adjustable height', 'Steerable front wheel', 'Hand brakes', 'Padded knee platform'],
    image: 'https://images.unsplash.com/photo-1581594549595-35f6edc7b762?w=800&q=80'
  },
  {
    id: '12',
    name: 'Electric Mobility Scooter - 3 Wheel',
    category: 'Mobility Aids',
    description: 'Compact three-wheel scooter with tight turning radius. Perfect for indoor use and navigating tight spaces.',
    features: ['Tight turning radius', '250 lb capacity', '10 mile range', 'Padded seat'],
    image: 'https://images.unsplash.com/photo-1585366119957-e9730b6d0f60?w=800&q=80'
  },
  {
    id: '13',
    name: 'Electric Mobility Scooter - 4 Wheel',
    category: 'Mobility Aids',
    description: 'Stable four-wheel scooter designed for outdoor use. Features larger wheels and longer battery range.',
    features: ['Enhanced stability', '300 lb capacity', '15-20 mile range', 'All-terrain wheels'],
    image: 'https://images.unsplash.com/photo-1585366119957-e9730b6d0f60?w=800&q=80'
  },
  {
    id: '14',
    name: 'Heavy Duty Mobility Scooter',
    category: 'Mobility Aids',
    description: 'Bariatric scooter with reinforced frame and high weight capacity. Built for comfort and durability.',
    features: ['500 lb capacity', 'Extra-wide seat', 'Heavy-duty construction', 'Extended range battery'],
    image: 'https://images.unsplash.com/photo-1585366119957-e9730b6d0f60?w=800&q=80'
  },
  {
    id: '15',
    name: 'Portable Mobility Scooter',
    category: 'Mobility Aids',
    description: 'Lightweight travel scooter that disassembles for easy transport. Airline-friendly design.',
    features: ['Lightweight components', 'Easy disassembly', 'Compact storage', 'TSA approved battery'],
    image: 'https://images.unsplash.com/photo-1585366119957-e9730b6d0f60?w=800&q=80'
  },
  {
    id: '16',
    name: 'Shower Chair with Back',
    category: 'Bath Safety',
    description: 'Durable shower chair with backrest and non-slip rubber tips. Tool-free assembly with adjustable height legs.',
    features: ['Adjustable height', '300 lb capacity', 'Drainage holes', 'Aluminum frame'],
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80'
  },
  {
    id: '17',
    name: 'Shower Chair without Back',
    category: 'Bath Safety',
    description: 'Backless shower stool for those who prefer open seating. Lightweight and easy to move.',
    features: ['Compact design', 'Height adjustable', '250 lb capacity', 'Non-slip feet'],
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80'
  },
  {
    id: '18',
    name: 'Bariatric Shower Chair',
    category: 'Bath Safety',
    description: 'Extra-wide shower chair with reinforced construction for larger individuals.',
    features: ['22-24 inch seat width', '500-600 lb capacity', 'Heavy-duty frame', 'Extra-large backrest'],
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80'
  },
  {
    id: '19',
    name: 'Shower Bench',
    category: 'Bath Safety',
    description: 'Long bench-style seat that spans the width of the tub. Provides ample seating space.',
    features: ['Extended seating area', 'Adjustable height', '400 lb capacity', 'Textured seat'],
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80'
  },
  {
    id: '20',
    name: 'Transfer Bench',
    category: 'Bath Safety',
    description: 'Bath bench that extends over tub edge allowing safe entry and exit. Reversible for left or right-hand use.',
    features: ['Reversible design', 'Adjustable legs', '400 lb capacity', 'Large seat area'],
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80'
  },
  {
    id: '21',
    name: 'Sliding Transfer Bench',
    category: 'Bath Safety',
    description: 'Transfer bench with sliding seat mechanism for easier positioning. Reduces twisting and strain.',
    features: ['Sliding seat', 'Locking mechanism', '300 lb capacity', 'Padded seat'],
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80'
  },
  {
    id: '22',
    name: 'Grab Bar - 12 inch',
    category: 'Bath Safety',
    description: 'Stainless steel grab bar for bathroom safety. Multiple mounting options available.',
    features: ['12 inch length', '500 lb capacity', 'Textured grip', 'Corrosion resistant'],
    image: 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?w=800&q=80'
  },
  {
    id: '23',
    name: 'Grab Bar - 18 inch',
    category: 'Bath Safety',
    description: 'Medium-length grab bar perfect for shower and tub installations.',
    features: ['18 inch length', '500 lb capacity', 'Stainless steel', 'Easy installation'],
    image: 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?w=800&q=80'
  },
  {
    id: '24',
    name: 'Grab Bar - 24 inch',
    category: 'Bath Safety',
    description: 'Standard length grab bar for longer reach applications.',
    features: ['24 inch length', '500 lb capacity', 'Multiple finishes', 'ADA compliant'],
    image: 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?w=800&q=80'
  },
  {
    id: '25',
    name: 'Grab Bar - 36 inch',
    category: 'Bath Safety',
    description: 'Extended length grab bar for full tub and shower coverage.',
    features: ['36 inch length', '500 lb capacity', 'Reinforced mounting', 'Textured surface'],
    image: 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?w=800&q=80'
  },
  {
    id: '26',
    name: 'Suction Cup Grab Bar',
    category: 'Bath Safety',
    description: 'Temporary grab bar with strong suction cups. No installation required, ideal for travel.',
    features: ['No drilling required', 'Removable', 'Indicator shows secure attachment', '300 lb capacity'],
    image: 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?w=800&q=80'
  },
  {
    id: '27',
    name: 'Raised Toilet Seat - Standard',
    category: 'Bath Safety',
    description: 'Elevated toilet seat adding 3-5 inches of height. Makes sitting and standing easier.',
    features: ['3-5 inch height options', 'Fits standard toilets', 'Easy to clean', 'Secure attachment'],
    image: 'https://images.unsplash.com/photo-1585421514738-01798e348b17?w=800&q=80'
  },
  {
    id: '28',
    name: 'Raised Toilet Seat with Armrests',
    category: 'Bath Safety',
    description: 'Elevated toilet seat with padded armrests for additional support when sitting and standing.',
    features: ['Padded armrests', 'Removable arms', '300 lb capacity', 'Height adjustable'],
    image: 'https://images.unsplash.com/photo-1585421514738-01798e348b17?w=800&q=80'
  },
  {
    id: '29',
    name: 'Bariatric Raised Toilet Seat',
    category: 'Bath Safety',
    description: 'Extra-wide elevated toilet seat with reinforced construction for larger individuals.',
    features: ['Wide seat opening', '600 lb capacity', 'Heavy-duty frame', 'Easy installation'],
    image: 'https://images.unsplash.com/photo-1585421514738-01798e348b17?w=800&q=80'
  },
  {
    id: '30',
    name: 'Toilet Safety Frame',
    category: 'Bath Safety',
    description: 'Freestanding toilet safety rail that provides armrest support without installation.',
    features: ['Freestanding design', 'Adjustable height', '300 lb capacity', 'Padded armrests'],
    image: 'https://images.unsplash.com/photo-1585421514738-01798e348b17?w=800&q=80'
  },
  {
    id: '31',
    name: 'Bath Mat - Non-Slip',
    category: 'Bath Safety',
    description: 'Textured bath mat with suction cups to prevent slipping in tub or shower.',
    features: ['Multiple sizes', 'Machine washable', 'Suction cup attachment', 'Mildew resistant'],
    image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800&q=80'
  },
  {
    id: '32',
    name: 'Shower Mat - Extra Long',
    category: 'Bath Safety',
    description: 'Extended length shower mat covering entire tub floor for maximum slip prevention.',
    features: ['Extra long coverage', 'Textured surface', 'Strong suction', 'Easy to clean'],
    image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800&q=80'
  },
  {
    id: '33',
    name: 'Hand-Held Shower Head',
    category: 'Bath Safety',
    description: 'Adjustable handheld shower with long hose. Makes bathing easier while seated.',
    features: ['5-6 foot hose', 'Multiple spray settings', 'Easy installation', 'Wall mount included'],
    image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?w=800&q=80'
  },
  {
    id: '34',
    name: 'Semi-Electric Hospital Bed',
    category: 'Daily Living',
    description: 'Hospital bed with electric head and foot adjustment. Manual height adjustment. Includes side rails.',
    features: ['Electric head/foot', 'Manual height', '450 lb capacity', 'Side rails included'],
    image: 'https://images.unsplash.com/photo-1631248055416-defd47d7d1ad?w=800&q=80'
  },
  {
    id: '35',
    name: 'Full Electric Hospital Bed',
    category: 'Daily Living',
    description: 'Fully electric adjustable bed with remote control for all positions including height.',
    features: ['Full electric adjustment', 'Hand control', '450 lb capacity', 'Split side rails'],
    image: 'https://images.unsplash.com/photo-1631248055416-defd47d7d1ad?w=800&q=80'
  },
  {
    id: '36',
    name: 'Low Height Hospital Bed',
    category: 'Daily Living',
    description: 'Hospital bed with ultra-low height setting to reduce fall risk. Full electric adjustment.',
    features: ['Low height option', 'Full electric', '450 lb capacity', 'Fall risk reduction'],
    image: 'https://images.unsplash.com/photo-1631248055416-defd47d7d1ad?w=800&q=80'
  },
  {
    id: '37',
    name: 'Bariatric Hospital Bed',
    category: 'Daily Living',
    description: 'Heavy-duty hospital bed with reinforced frame and extra-wide sleeping surface.',
    features: ['42-48 inch width', '600-1000 lb capacity', 'Heavy-duty frame', 'Reinforced motors'],
    image: 'https://images.unsplash.com/photo-1631248055416-defd47d7d1ad?w=800&q=80'
  },
  {
    id: '38',
    name: 'Hospital Bed Mattress - Foam',
    category: 'Daily Living',
    description: 'High-density foam mattress designed for hospital beds. Pressure-relieving surface.',
    features: ['Pressure relief', 'Waterproof cover', 'Multiple thickness options', 'Fire retardant'],
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80'
  },
  {
    id: '39',
    name: 'Hospital Bed Mattress - Air',
    category: 'Daily Living',
    description: 'Alternating pressure mattress system to prevent pressure sores. Includes pump.',
    features: ['Alternating pressure', 'Pump included', 'Adjustable settings', 'Low air loss option'],
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80'
  },
  {
    id: '40',
    name: 'Overbed Table',
    category: 'Daily Living',
    description: 'Adjustable height table that rolls over bed. Tilting surface for reading or eating.',
    features: ['Height adjustable', 'Tilting top', 'Locking wheels', '50 lb capacity'],
    image: 'https://images.unsplash.com/photo-1628771065518-0d82f1938462?w=800&q=80'
  },
  {
    id: '41',
    name: 'Bedside Commode',
    category: 'Daily Living',
    description: 'Portable toilet chair with removable bucket. Can be used as toilet safety frame.',
    features: ['3-in-1 design', '300 lb capacity', 'Padded seat', 'Removable arms'],
    image: 'https://images.unsplash.com/photo-1582719471137-c3967ffb1c42?w=800&q=80'
  },
  {
    id: '42',
    name: 'Drop-Arm Commode',
    category: 'Daily Living',
    description: 'Commode with drop-down armrest for easier side transfers. Extra stability.',
    features: ['Drop-arm design', 'Easier transfers', '350 lb capacity', 'Padded seat'],
    image: 'https://images.unsplash.com/photo-1582719471137-c3967ffb1c42?w=800&q=80'
  },
  {
    id: '43',
    name: 'Bariatric Commode',
    category: 'Daily Living',
    description: 'Heavy-duty commode with extra-wide seat and reinforced frame.',
    features: ['24 inch seat width', '600 lb capacity', 'Heavy-duty construction', 'Large bucket'],
    image: 'https://images.unsplash.com/photo-1582719471137-c3967ffb1c42?w=800&q=80'
  },
  {
    id: '44',
    name: 'Reacher Grabber - 26 inch',
    category: 'Daily Living',
    description: 'Long-reach grabber tool with magnetic tip. Reduces bending and reaching.',
    features: ['26 inch reach', 'Magnetic tip', 'Lightweight', 'Easy-grip trigger'],
    image: 'https://images.unsplash.com/photo-1587049633312-d628ae50a8ae?w=800&q=80'
  },
  {
    id: '45',
    name: 'Reacher Grabber - 32 inch',
    category: 'Daily Living',
    description: 'Extended reach grabber perfect for picking up items from floor or high shelves.',
    features: ['32 inch reach', 'Rubberized jaw', 'Rotating head', 'Folding option available'],
    image: 'https://images.unsplash.com/photo-1587049633312-d628ae50a8ae?w=800&q=80'
  },
  {
    id: '46',
    name: 'Dressing Stick',
    category: 'Daily Living',
    description: 'Long stick with hooks on both ends to assist with dressing. Helps pull on clothing.',
    features: ['Multiple hooks', 'Lightweight', '24-28 inch length', 'Non-slip grip'],
    image: 'https://images.unsplash.com/photo-1587049352846-4a222e784589?w=800&q=80'
  },
  {
    id: '47',
    name: 'Sock Aid',
    category: 'Daily Living',
    description: 'Device that helps put on socks without bending. Includes long handles.',
    features: ['Easy sock application', 'Long handles', 'Flexible core', 'Foam or terry cloth'],
    image: 'https://images.unsplash.com/photo-1587049352846-4a222e784589?w=800&q=80'
  },
  {
    id: '48',
    name: 'Shoe Horn - Long Handle',
    category: 'Daily Living',
    description: 'Extended handle shoe horn eliminates need to bend when putting on shoes.',
    features: ['24-32 inch handle', 'Sturdy construction', 'Hanging loop', 'Lightweight'],
    image: 'https://images.unsplash.com/photo-1587049352846-4a222e784589?w=800&q=80'
  },
  {
    id: '49',
    name: 'Button Hook',
    category: 'Daily Living',
    description: 'Tool to assist with buttoning shirts and pants. Helpful for limited dexterity.',
    features: ['Easy button manipulation', 'Ergonomic handle', 'Zipper pull included', 'Compact'],
    image: 'https://images.unsplash.com/photo-1587049352846-4a222e784589?w=800&q=80'
  },
  {
    id: '50',
    name: 'Leg Lifter',
    category: 'Daily Living',
    description: 'Strap device to help lift legs into bed or wheelchair. Reduces strain.',
    features: ['Rigid construction', 'Long strap', 'Foot loop', 'Multiple lengths'],
    image: 'https://images.unsplash.com/photo-1587049352846-4a222e784589?w=800&q=80'
  },
  {
    id: '51',
    name: 'Adult Briefs - Maximum Absorbency',
    category: 'Incontinence',
    description: 'High-absorbency disposable briefs with odor control and wetness indicator.',
    features: ['Maximum protection', 'Odor control', 'Wetness indicator', 'Various sizes S-XXL'],
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80'
  },
  {
    id: '52',
    name: 'Adult Briefs - Moderate Absorbency',
    category: 'Incontinence',
    description: 'Everyday protection briefs with moderate absorbency level.',
    features: ['Moderate protection', 'Comfortable fit', 'Breathable', 'Bulk packaging available'],
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80'
  },
  {
    id: '53',
    name: 'Pull-Up Protective Underwear',
    category: 'Incontinence',
    description: 'Pull-on style protective underwear that looks and feels like regular underwear.',
    features: ['Discreet design', 'Easy on/off', 'Absorbent core', 'Tear-away sides'],
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80'
  },
  {
    id: '54',
    name: 'Overnight Protective Underwear',
    category: 'Incontinence',
    description: 'Extra absorbent pull-ups designed for overnight protection.',
    features: ['Extended wear', 'Extra absorbency', 'Odor control', 'Comfortable waistband'],
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80'
  },
  {
    id: '55',
    name: 'Incontinence Pads - Light',
    category: 'Incontinence',
    description: 'Thin absorbent pads for light bladder leakage. Discreet protection.',
    features: ['Light absorbency', 'Adhesive backing', 'Discreet', 'Individually wrapped'],
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80'
  },
  {
    id: '56',
    name: 'Incontinence Pads - Heavy',
    category: 'Incontinence',
    description: 'Maximum absorbency pads for heavy incontinence. Extra-long length.',
    features: ['Maximum absorbency', 'Extra length', 'Adhesive strips', 'Odor control'],
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=800&q=80'
  },
  {
    id: '57',
    name: 'Bed Pads - Disposable',
    category: 'Incontinence',
    description: 'Single-use underpads for bed and chair protection. Absorbent with waterproof backing.',
    features: ['Disposable', 'Waterproof backing', 'Various sizes', 'Bulk options'],
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80'
  },
  {
    id: '58',
    name: 'Bed Pads - Reusable',
    category: 'Incontinence',
    description: 'Washable waterproof bed pads. Economical and environmentally friendly.',
    features: ['Machine washable', 'Waterproof', 'Multiple sizes', 'Durable construction'],
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80'
  },
  {
    id: '59',
    name: 'Chair Pads',
    category: 'Incontinence',
    description: 'Absorbent pads designed for wheelchair or furniture protection.',
    features: ['Non-slip backing', 'Washable or disposable', 'Various sizes', 'Cushioned'],
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80'
  },
  {
    id: '60',
    name: 'Male Urinal',
    category: 'Incontinence',
    description: 'Spill-proof portable urinal with handle and cap. Easy to clean.',
    features: ['1000ml capacity', 'Spill-proof', 'Glow-in-dark option', 'Easy grip handle'],
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80'
  },
  {
    id: '61',
    name: 'Female Urinal',
    category: 'Incontinence',
    description: 'Ergonomically designed urinal for women. Splash-proof with secure cap.',
    features: ['Ergonomic design', 'Splash guard', 'Easy to use', 'Portable'],
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80'
  },
  {
    id: '62',
    name: 'Urinal with Holder',
    category: 'Incontinence',
    description: 'Urinal system with bedside holder for easy nighttime access.',
    features: ['Includes holder', 'Easy access', 'Secure mounting', '1200ml capacity'],
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80'
  },
  {
    id: '63',
    name: 'Nebulizer Machine - Compressor',
    category: 'Respiratory',
    description: 'Compressor nebulizer for medication delivery. Includes tubing and mouthpiece.',
    features: ['Compact design', 'Quiet operation', 'Fast treatment time', 'Easy to clean'],
    image: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&q=80'
  },
  {
    id: '64',
    name: 'Nebulizer Machine - Portable',
    category: 'Respiratory',
    description: 'Battery-operated portable nebulizer. Perfect for travel and on-the-go treatment.',
    features: ['Battery powered', 'Compact', 'Rechargeable', 'Quiet'],
    image: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&q=80'
  },
  {
    id: '65',
    name: 'Oxygen Concentrator - 5 Liter',
    category: 'Respiratory',
    description: 'Home oxygen concentrator providing continuous oxygen therapy.',
    features: ['5 LPM flow', 'Continuous operation', 'Alarm system', 'Low maintenance'],
    image: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&q=80'
  },
  {
    id: '66',
    name: 'Portable Oxygen Concentrator',
    category: 'Respiratory',
    description: 'Lightweight portable oxygen concentrator with battery. FAA approved.',
    features: ['Lightweight', 'Battery operated', 'FAA approved', 'Pulse or continuous flow'],
    image: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&q=80'
  },
  {
    id: '67',
    name: 'Pulse Oximeter',
    category: 'Respiratory',
    description: 'Fingertip pulse oximeter measuring oxygen saturation and heart rate.',
    features: ['Accurate readings', 'LED display', 'Battery included', 'Portable'],
    image: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&q=80'
  },
  {
    id: '68',
    name: 'CPAP Machine',
    category: 'Respiratory',
    description: 'Continuous positive airway pressure machine for sleep apnea treatment.',
    features: ['Auto-adjusting pressure', 'Heated humidifier', 'Data tracking', 'Quiet operation'],
    image: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&q=80'
  },
  {
    id: '69',
    name: 'Blood Pressure Monitor - Automatic',
    category: 'Diagnostics',
    description: 'Automatic upper arm blood pressure monitor with large display.',
    features: ['One-touch operation', 'Memory storage', 'Irregular heartbeat detection', 'Large cuff'],
    image: 'https://images.unsplash.com/photo-1615461065929-4676d1073753?w=800&q=80'
  },
  {
    id: '70',
    name: 'Blood Pressure Monitor - Wrist',
    category: 'Diagnostics',
    description: 'Compact wrist blood pressure monitor. Portable and easy to use.',
    features: ['Wrist measurement', 'Portable', 'Memory function', 'Battery operated'],
    image: 'https://images.unsplash.com/photo-1615461065929-4676d1073753?w=800&q=80'
  },
  {
    id: '71',
    name: 'Digital Thermometer',
    category: 'Diagnostics',
    description: 'Fast-reading digital thermometer for oral, rectal, or underarm use.',
    features: ['10 second reading', 'Fever alarm', 'Memory recall', 'Waterproof'],
    image: 'https://images.unsplash.com/photo-1584511643103-436efde5e7d0?w=800&q=80'
  },
  {
    id: '72',
    name: 'Infrared Forehead Thermometer',
    category: 'Diagnostics',
    description: 'Non-contact infrared thermometer. Quick and hygienic temperature measurement.',
    features: ['No contact needed', '1 second reading', 'Silent mode', 'Memory storage'],
    image: 'https://images.unsplash.com/photo-1584511643103-436efde5e7d0?w=800&q=80'
  },
  {
    id: '73',
    name: 'Glucose Meter Kit',
    category: 'Diagnostics',
    description: 'Blood glucose monitoring system with meter, lancets, and test strips.',
    features: ['Fast results', 'Small sample size', 'Data storage', 'Easy to use'],
    image: 'https://images.unsplash.com/photo-1615461065929-4676d1073753?w=800&q=80'
  },
  {
    id: '74',
    name: 'Stethoscope',
    category: 'Diagnostics',
    description: 'Dual-head stethoscope for general diagnostic use.',
    features: ['Dual head design', 'Adjustable earpieces', 'Quality acoustics', 'Various colors'],
    image: 'https://images.unsplash.com/photo-1581594549595-f9c0faaa5f1e?w=800&q=80'
  },
  {
    id: '75',
    name: 'Compression Stockings - Knee High',
    category: 'Compression Support',
    description: 'Graduated compression stockings promoting circulation. Available in multiple compression levels.',
    features: ['15-20 or 20-30 mmHg', 'Knee high length', 'Various colors', 'Moisture wicking'],
    image: 'https://images.unsplash.com/photo-1612838320302-4b3b3b3b3b3b?w=800&q=80'
  },
  {
    id: '76',
    name: 'Compression Stockings - Thigh High',
    category: 'Compression Support',
    description: 'Thigh-high compression stockings with silicone band to prevent rolling.',
    features: ['Medical grade compression', 'Stay-up silicone band', 'Reinforced heel', 'Multiple sizes'],
    image: 'https://images.unsplash.com/photo-1612838320302-4b3b3b3b3b3b?w=800&q=80'
  },
  {
    id: '77',
    name: 'Back Support Brace',
    category: 'Compression Support',
    description: 'Lumbar support brace providing compression and stability to lower back.',
    features: ['Adjustable compression', 'Breathable material', 'Removable stays', 'S-XXL sizes'],
    image: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=800&q=80'
  },
  {
    id: '78',
    name: 'Knee Brace',
    category: 'Compression Support',
    description: 'Hinged knee brace providing support and stability. Ideal for arthritis or post-injury.',
    features: ['Hinged design', 'Adjustable straps', 'Breathable fabric', 'Universal fit'],
    image: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=800&q=80'
  },
  {
    id: '79',
    name: 'Ankle Support',
    category: 'Compression Support',
    description: 'Compression ankle support with adjustable straps. Provides stability without restricting movement.',
    features: ['Adjustable compression', 'Fits in shoes', 'Breathable', 'Left or right'],
    image: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=800&q=80'
  },
  {
    id: '80',
    name: 'Wrist Brace',
    category: 'Compression Support',
    description: 'Carpal tunnel wrist brace with splint support. Ideal for daytime or nighttime use.',
    features: ['Splint support', 'Adjustable fit', 'Breathable material', 'Various sizes'],
    image: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=800&q=80'
  }
];

export const categories = [
  {
    id: 'mobility-aids',
    name: 'Mobility Aids',
    description: 'Walkers, wheelchairs, canes, scooters and more to enhance independence and mobility',
    icon: 'walking',
    productCount: 200
  },
  {
    id: 'bath-safety',
    name: 'Bath Safety',
    description: 'Shower chairs, grab bars, transfer benches and safety equipment for bathroom',
    icon: 'shower',
    productCount: 150
  },
  {
    id: 'daily-living',
    name: 'Daily Living',
    description: 'Hospital beds, reachers, dressing aids and equipment for everyday comfort',
    icon: 'bed',
    productCount: 180
  },
  {
    id: 'incontinence',
    name: 'Incontinence',
    description: 'Protective underwear, bed pads, urinals and commode solutions',
    icon: 'accessibility',
    productCount: 120
  },
  {
    id: 'respiratory',
    name: 'Respiratory',
    description: 'Nebulizers, oxygen concentrators, CPAP machines and breathing assistance',
    icon: 'wind',
    productCount: 90
  },
  {
    id: 'diagnostics',
    name: 'Diagnostics',
    description: 'Blood pressure monitors, thermometers, glucose meters and diagnostic tools',
    icon: 'activity',
    productCount: 85
  },
  {
    id: 'compression-support',
    name: 'Compression Support',
    description: 'Compression stockings, braces, supports for back, knee, ankle and wrist',
    icon: 'shield',
    productCount: 110
  }
];

export const testimonials = [
  {
    id: '1',
    name: 'Margaret Thompson',
    location: 'Springfield, IL',
    rating: 5,
    text: 'The team at Kalorama Medical helped me find the perfect mobility equipment. Professional service and fast delivery!',
    date: '2026-06-15'
  },
  {
    id: '2',
    name: 'Robert Chen',
    location: 'Portland, OR',
    rating: 5,
    text: 'Excellent quality products and outstanding customer support. They worked with my insurance and made everything easy.',
    date: '2026-06-10'
  },
  {
    id: '3',
    name: 'Linda Martinez',
    location: 'Austin, TX',
    rating: 5,
    text: 'I appreciate the expert guidance I received. The bathroom safety equipment has made such a difference in my daily life.',
    date: '2026-06-05'
  },
  {
    id: '4',
    name: 'James Wilson',
    location: 'Boston, MA',
    rating: 5,
    text: 'Second time ordering from Kalorama Medical. The products are durable and exactly as described. Highly recommend!',
    date: '2026-05-28'
  }
];

export const faqs = [
  {
    id: '1',
    question: 'Do you accept insurance?',
    answer: 'Yes, we work with most major insurance providers including Medicare and Medicaid. Our team can help verify your coverage and handle the paperwork for you.'
  },
  {
    id: '2',
    question: 'What is your return policy?',
    answer: 'We offer a 30-day return policy on most products. Items must be unused and in original packaging. Some items may have different return policies due to hygiene reasons.'
  },
  {
    id: '3',
    question: 'Do you offer delivery and setup?',
    answer: 'Yes, we provide delivery services and can arrange professional setup for larger equipment. Contact us for details.'
  },
  {
    id: '4',
    question: 'How do I know which product is right for me?',
    answer: 'Our experienced staff can provide personalized recommendations based on your needs. Contact us to discuss your requirements.'
  },
  {
    id: '5',
    question: 'What areas do you serve?',
    answer: 'We ship nationwide and offer local delivery services in select areas.'
  },
  {
    id: '6',
    question: 'Do you have products in stock?',
    answer: 'Most items are in stock and ready to ship. Contact us for current availability on specific products.'
  },
  {
    id: '7',
    question: 'Can I try equipment before purchasing?',
    answer: 'Yes, we offer product demonstrations. Contact us to schedule an appointment.'
  },
  {
    id: '8',
    question: 'Do you offer financing options?',
    answer: 'Yes, we offer flexible financing options. Contact us to learn more about payment plans.'
  }
];
